import { AxiosResponse } from 'axios';
import Api from '../api';
import { ModuleType } from '../modules.types';

const GetByIdApi = ({
  moduleType,
  id,
}: {
  moduleType: ModuleType;
  id: number;
}): Promise<AxiosResponse> => {
  const path = `/admin/${moduleType}/get/${id}`;
  return Api.getInstance().request.get(path);
};
export default GetByIdApi;
